import { NgModule } from '@angular/core';
import { environment } from '../../environments/environment';

@NgModule({
  providers: [
    {
      provide: 'apiBaseURL',
      useValue: `${environment.apiUrl}`
    },
    {
      provide: 'apiSessionAccount',
      useValue: 'sessions/account'
    }
  ]
})
export class CoreModule {}
